<template>
  <div class="ucenter flex flex-col grow shrink relative h-[100vh] w-full box-border relative m-0 p-0 overflow-hidden">
    <UserCenterHeaderBar class="pt-2 pb-2" :simple="false"></UserCenterHeaderBar>  
    <div class="ucenter-body flex w-full flex-1 min-h-0">
        <UserCenterSideBar :currentMenuUrl="currentMenuUrl"></UserCenterSideBar>
        <AppMain class="content-view"></AppMain>
    </div>
  </div>
</template>

<script>
import {AppMain, UserCenterSideBar, UserCenterHeaderBar} from './components'
export default {
  name: 'UserCenterLayout',
  components: {UserCenterSideBar, UserCenterHeaderBar, AppMain},
  data() {
    return {
        currentMenuUrl: '',
     }
  },
  provide() {
    return {
        updateCurrentMenuUrl: this.updateCurrentMenuUrl
    }
  },
  computed: {

  },
  methods: {
    updateCurrentMenuUrl(url) {
        this.currentMenuUrl = url;
    },
  }
}
</script>

<style lang="scss" scoped>

.ucenter {
    background-image: linear-gradient(103deg, rgba(255, 255, 255, 0.20) 10.04%, rgba(241, 153, 207, 0.20) 52.74%, rgba(159, 194, 238, 0.20) 60.55%);
    background-color: #fafafa;
}

.content-view {
    width: auto;
    height: auto;
    min-height: 0;
    padding: 40px 40px 56px 40px;
    box-sizing: border-box;    
    position: relative;
    border-top-left-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 0 2px rgba(0,0,0,0.12), 0 4px 8px rgba(0,0,0,0.14);    
    overflow-x: hidden;
    overflow-y: auto;
    flex-grow: 1;
    -webkit-overflow-scrolling: touch;
}

@media (max-width: 960px) {
    .content-view {
        width:100% !important;
        margin-left: 0px !important;
        padding: 125px 0px 55px 0px
    }
}

.content-view>.user-info-main {
    margin-top: 10px;
    width: 100%;
    height: calc(100% - 6%);
    display: flex;
    justify-content: space-between
}

.content-view .static-order-main {
    width: 100%
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:first-of-type {
    width: 100%;
    max-width: 266px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input {
    width: 100%;
    height: 100%
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border-radius: 10px;
    border: none;
    outline: none;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(2) {
    width: 100%;
    max-width: 556px
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content {
    width: 100%
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item {
    width: calc(100% - 12px)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input .el-input__inner {
    width: 100%;
    border: none;
    padding-left: 45px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input .el-input__icon {
    font-size: 24px;
    font-weight: bold;
    color: #276dfd;
    line-height: 56px
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(3) {
    width: 100%;
    max-width: 266px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select {
    width: 100%;
    height: 100%
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input {
    width: 100%;
    height: 100%
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input .el-input__inner {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border-radius: 10px;
    border: none;
    outline: none;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:last-of-type {
    width: 100%;
    max-width: 163px;
    height: 56px
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:last-of-type .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .static-order-main .static-order-top .demo-form-inline>.el-form-item:last-of-type .el-form-item__content .el-button {
    width: 100%;
    height: 100%;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff
}

.content-view .static-order-main .static-order-center .list-table .el-table {
    min-height: 650px
}

.content-view .static-order-main .static-order-center .list-table .el-table::before {
    height: 0px
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__body-wrapper {
    border-radius: 0px 0px 10px 10px
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__header thead {
    width: 100%;
    height: 56px;
    background-color: #dce4fa;
    border-radius: 10px 10px 0px 0px
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__header thead tr {
    height: 56px;
    background-color: #dce4fa
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell {
    height: 56px;
    background-color: #dce4fa
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell .cell {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell:first-of-type {
    border-radius: 10px 0px 0px 0px
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell:nth-of-type(9) {
    border-radius: 0px 10px 0px 0px
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell {
    height: 56px
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: rgba(17,24,46,0.6)
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell .operate {
    position: relative
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell .operate .operate-tips {
    position: absolute;
    right: 0;
    top: 50%;
    padding: 4px 11px;
    background-color: rgba(34,50,101,0.1);
    border-radius: 6px;
    font-family: "Poppins-Medium";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 21px;
    letter-spacing: 0px;
    color: #223265
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell .operate:first-of-type {
    margin-right: 17px
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell .operate:last-of-type {
    margin-left: 17px
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__body tbody tr.el-table__row:nth-child(odd) {
    background-color: #fcfcfe
}

.content-view .static-order-main .static-order-center .list-table .el-table .el-table__body tbody tr.el-table__row:nth-child(even) {
    background-color: #f0f2f9
}

.content-view .static-order-main .static-order-center .list-table .el-pagination {
    text-align: center
}

.content-view .ips-order-main {
    width: 100%
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:first-of-type {
    width: 100%;
    max-width: 266px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input {
    width: 100%;
    height: 100%
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border-radius: 10px;
    border: none;
    outline: none;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(2) {
    width: 100%;
    max-width: 556px
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content {
    width: 100%
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item {
    width: calc(100% - 12px)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input .el-input__inner {
    width: 100%;
    border: none;
    padding-left: 45px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input .el-input__icon {
    font-size: 24px;
    font-weight: bold;
    color: #276dfd;
    line-height: 56px
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(3) {
    width: 100%;
    max-width: 266px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select {
    width: 100%;
    height: 100%
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input {
    width: 100%;
    height: 100%
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input .el-input__inner {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border-radius: 10px;
    border: none;
    outline: none;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:last-of-type {
    width: 100%;
    max-width: 163px;
    height: 56px
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:last-of-type .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .ips-order-main .ips-order-top .demo-form-inline>.el-form-item:last-of-type .el-form-item__content .el-button {
    width: 100%;
    height: 100%;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff
}

.content-view .ips-order-main .ips-order-center .list-table .el-table {
    min-height: 650px
}

.content-view .ips-order-main .ips-order-center .list-table .el-table::before {
    height: 0px
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__body-wrapper {
    border-radius: 0px 0px 10px 10px
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__header thead {
    width: 100%;
    height: 56px;
    background-color: #dce4fa;
    border-radius: 10px 10px 0px 0px
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__header thead tr {
    height: 56px;
    background-color: #dce4fa
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell {
    height: 56px;
    background-color: #dce4fa
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell .cell {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell:first-of-type {
    border-radius: 10px 0px 0px 0px
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell:nth-of-type(8) {
    border-radius: 0px 10px 0px 0px
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell {
    height: 56px
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: rgba(17,24,46,0.6)
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell .operate:first-of-type {
    margin-right: 17px
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell .operate:last-of-type {
    margin-left: 17px
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__body tbody tr.el-table__row:nth-child(odd) {
    background-color: #fcfcfe
}

.content-view .ips-order-main .ips-order-center .list-table .el-table .el-table__body tbody tr.el-table__row:nth-child(even) {
    background-color: #f0f2f9
}

.content-view .ips-order-main .ips-order-center .list-table .el-pagination {
    text-align: center
}

.content-view .staticip-main {
    width: 100%
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:first-of-type,.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(2) {
    width: 100%;
    max-width: 266px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content,.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input,.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-input {
    width: 100%;
    height: 100%
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input .el-input__inner,.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border-radius: 10px;
    border: none;
    outline: none;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-webkit-input-placeholder,.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-moz-input-placeholder,.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-ms-input-placeholder,.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(3) {
    width: 100%;
    max-width: 266px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select {
    width: 100%;
    height: 100%
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input {
    width: 100%;
    height: 100%
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input .el-input__inner {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border-radius: 10px;
    border: none;
    outline: none;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(4) {
    width: 100%;
    max-width: 163px;
    height: 56px
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(4) .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(4) .el-form-item__content .el-button {
    width: 100%;
    height: 100%;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(5) {
    width: 100%;
    max-width: 163px;
    height: 56px
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(5) .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(5) .el-form-item__content .el-button {
    width: 100%;
    height: 100%;
    background-color: rgba(39,109,253,0.2);
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #276dfd
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(6) {
    width: auto;
    max-width: auto;
    height: 56px
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(6) .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .staticip-main .staticip-top .demo-form-inline>.el-form-item:nth-of-type(6) .el-form-item__content .el-button {
    width: 100%;
    height: 100%;
    background-color: rgba(39,109,253,0.2);
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #276dfd
}

.content-view .staticip-main .staticip-center .list-table .el-table {
    min-height: 650px
}

.content-view .staticip-main .staticip-center .list-table .el-table::before {
    height: 0px
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__body-wrapper {
    border-radius: 0px 0px 10px 10px
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__header thead {
    width: 100%;
    height: 56px;
    background-color: #dce4fa;
    border-radius: 10px 10px 0px 0px
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__header thead tr {
    height: 56px;
    background-color: #dce4fa
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__header thead tr th.el-table__cell {
    height: 56px;
    background-color: #dce4fa
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__header thead tr th.el-table__cell .cell {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__header thead tr th.el-table__cell:first-of-type {
    border-radius: 10px 0px 0px 0px
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__header thead tr th.el-table__cell:nth-of-type(9) {
    border-radius: 0px 10px 0px 0px
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell {
    height: 56px
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: rgba(17,24,46,0.6)
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell .operate {
    font-family: 'Poppins-Medium';
    font-size: 16px
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__body tbody tr.el-table__row:nth-child(odd) {
    background-color: #fcfcfe
}

.content-view .staticip-main .staticip-center .list-table .el-table .el-table__body tbody tr.el-table__row:nth-child(even) {
    background-color: #f0f2f9
}

.content-view .staticip-main .staticip-center .list-table .el-pagination {
    text-align: center
}

.content-view .random-order-main {
    width: 100%
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:first-of-type {
    width: 100%;
    max-width: 266px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input {
    width: 100%;
    height: 100%
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border-radius: 10px;
    border: none;
    outline: none;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:first-of-type .el-form-item__content .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(2) {
    width: 100%;
    max-width: 556px
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content {
    width: 100%
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item {
    width: calc(100% - 12px)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input .el-input__inner {
    width: 100%;
    border: none;
    padding-left: 45px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(2) .el-form-item__content .el-form-item .el-input .el-input__icon {
    font-size: 24px;
    font-weight: bold;
    color: #276dfd;
    line-height: 56px
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(3) {
    width: 100%;
    max-width: 266px;
    height: 56px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select {
    width: 100%;
    height: 100%
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input {
    width: 100%;
    height: 100%
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input .el-input__inner {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border-radius: 10px;
    border: none;
    outline: none;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: #11182e
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-webkit-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-moz-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:nth-of-type(3) .el-form-item__content .el-select .el-input input::-ms-input-placeholder {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    color: rgba(204,204,204,0.6)
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:last-of-type {
    width: 100%;
    max-width: 163px;
    height: 56px
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:last-of-type .el-form-item__content {
    width: 100%;
    height: 100%
}

.content-view .random-order-main .random-order-top .demo-form-inline>.el-form-item:last-of-type .el-form-item__content .el-button {
    width: 100%;
    height: 100%;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff
}

.content-view .random-order-main .random-order-center .list-table .el-table {
    min-height: 650px
}

.content-view .random-order-main .random-order-center .list-table .el-table::before {
    height: 0px
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__body-wrapper {
    border-radius: 0px 0px 10px 10px
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__header thead {
    width: 100%;
    height: 56px;
    background-color: #dce4fa;
    border-radius: 10px 10px 0px 0px
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__header thead tr {
    height: 56px;
    background-color: #dce4fa
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell {
    height: 56px;
    background-color: #dce4fa
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell .cell {
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell:first-of-type {
    border-radius: 10px 0px 0px 0px
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__header thead tr th.el-table__cell:nth-of-type(10) {
    border-radius: 0px 10px 0px 0px
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell {
    height: 56px
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: rgba(17,24,46,0.6)
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell .operate:first-of-type {
    margin-right: 17px
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__body tbody tr.el-table__row td.el-table__cell .cell .operate:last-of-type {
    margin-left: 17px
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__body tbody tr.el-table__row:nth-child(odd) {
    background-color: #fcfcfe
}

.content-view .random-order-main .random-order-center .list-table .el-table .el-table__body tbody tr.el-table__row:nth-child(even) {
    background-color: #f0f2f9
}

.content-view .random-order-main .random-order-center .list-table .el-pagination {
    text-align: center
}

.content-view .popup-box {
    position: fixed;
    z-index: 10001;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 504px;
    min-height: 185px;
    padding: 56px 40px 20px 40px;
    background-color: #ffffff;
    border-radius: 20px
}

.content-view .popup-box .popup-box-close {
    position: absolute;
    top: 24px;
    right: 24px;
    cursor: pointer
}

.content-view .popup-box .form-box .form--inline {
    width: 100%;
    max-width: 580px;
    height: 66px;
    margin-top: 32px;
    position: relative;
    background-color: #f0f2f9;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 0 24px
}

.content-view .popup-box .form-box .form--inline label {
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 66px;
    letter-spacing: 0px;
    color: #11182e;
    opacity: 0.2
}

.content-view .popup-box .form-box .form--inline input {
    width: calc(100% - 40px);
    height: 0px;
    padding-right: 40px;
    border: none;
    outline: none;
    background-color: #f0f2f9;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #223265
}

.content-view .popup-box .form-box .form--inline input::-webkit-input-placeholder {
    color: #999999;
    font-size: 16px
}

.content-view .popup-box .form-box .form--inline.active label {
    display: inline-block;
    font-size: 12px;
    line-height: 1;
    position: relative;
    top: 5px
}

.content-view .popup-box .form-box .form--inline.active input {
    display: block;
    height: 39px;
    margin-top: 5px
}

.content-view .popup-box .btn {
    width: 100%;
    max-width: 580px;
    height: 66px;
    margin-top: 32px;
    background-color: #276dfd;
    border-radius: 10px;
    cursor: pointer
}

.content-view .popup-box .btn a {
    display: inline-block;
    width: 100%;
    height: 100%;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: 'Poppins-SemiBold';
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    text-align: center;
    line-height: 66px;
    letter-spacing: 0px;
    color: #ffffff
}

.content-view .renew-bluk .el-dialog {
    max-width: 651px;
    border-radius: 12px
}

.content-view .renew-bluk .el-dialog .el-dialog__header {
    padding-top: 8%;
    padding-bottom: 5.5%
}

.content-view .renew-bluk .el-dialog .el-dialog__header .el-dialog__title {
    font-size: 24px;
    font-family: "Poppins-Bold";
    font-weight: bold;
    color: #223265;
    line-height: 35px
}

.content-view .renew-bluk .el-dialog .el-dialog__header .el-dialog__headerbtn i {
    font-size: 22px
}

.content-view .renew-bluk .el-dialog .el-dialog__body {
    padding: 0;
    padding-bottom: 0px
}

.content-view .renew-bluk .el-dialog .el-dialog__body .renew-bluk-center .ips-list {
    max-height: 410px;
    overflow-y: auto;
    padding: 0 3% 0 6%;
    box-sizing: border-box;
    margin-right: 3%
}

.content-view .renew-bluk .el-dialog .el-dialog__body .renew-bluk-center .ips-list .ip-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.94% 4.25%;
    box-sizing: border-box
}

.content-view .renew-bluk .el-dialog .el-dialog__body .renew-bluk-center .ips-list .ip-div .ip {
    font-size: 16px;
    font-family: "Poppins-SemiBold";
    font-weight: 600;
    color: #6A6F80;
    line-height: 25px
}

.content-view .renew-bluk .el-dialog .el-dialog__body .renew-bluk-center .ips-list .ip-div i {
    color: #6A6F80;
    font-size: 15px;
    cursor: pointer
}

.content-view .renew-bluk .el-dialog .el-dialog__body .renew-bluk-center .ips-list .ip-div:hover {
    background: #F0F2F9;
    border-radius: 8px
}

.content-view .renew-bluk .el-dialog .el-dialog__body .renew-bluk-center .ips-list .ip-div:hover .ip {
    color: #233367
}

.content-view .renew-bluk .el-dialog .el-dialog__body .renew-bluk-center .ips-list .ip-div:hover i {
    color: #276DFD
}

.content-view .renew-bluk .el-dialog .el-dialog__footer {
    padding: 5.1% 6% 8.6% 6%;
    border-top: 1px solid #EEEEEE
}

.content-view .renew-bluk .el-dialog .el-dialog__footer .dialog-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between
}

.content-view .renew-bluk .el-dialog .el-dialog__footer .dialog-footer .btn-b {
    max-width: 268px;
    padding: 21px 0;
    width: 47%;
    box-sizing: border-box;
    background: #276DFD;
    border-radius: 12px;
    font-size: 18px;
    font-family: "Poppins-Bold";
    font-weight: bold;
    color: #FFFFFF
}

.content-view .renew-bluk .el-dialog .el-dialog__footer .dialog-footer .btn-w {
    margin: 0;
    max-width: 268px;
    padding: 21px 0;
    width: 47%;
    box-sizing: border-box;
    border-radius: 12px;
    border: 1px solid #276DFD;
    font-size: 18px;
    font-family: "Poppins-Bold";
    font-weight: bold;
    color: #276DFD
}

@media (max-width: 1200px) {
    .content-view {
        margin-left:90px
    }

    .content-view>.user-info-main {
        display: flex;
        flex-direction: column
    }

    .content-view .account_setting_main .add_dialog .el-dialog {
        width: 50% !important
    }

    .content-view .account_setting_main .iplist {
        padding-bottom: 45px
    }

    .content-view .account_setting_main .iplist .ip_list {
        overflow: auto;
        padding-bottom: 10px
    }

    .content-view .account_setting_main .iplist .ip_list.ip_guide {
        min-height: 0
    }

    .content-view .account_setting_main .iplist .guide_link {
        bottom: 15px
    }
}

@media (max-width: 1000px) {
    .content-view>.user-info-main .user-info-right .user-order-item .order-item-right {
        flex-direction:column
    }
}

@media (max-width: 960px) {
    .content-view-w {
        padding:0.6rem 0px 55px 0px !important
    }

    .content-view-wi {
        padding: 0.8rem .1rem 55px .1rem !important
    }

    .content-view .user-order-notice {
        display: none
    }

    .el-message-box {
        width: 100% !important
    }
}

@media (max-width: 800px) {
    .content-view>.user-info-main .user-info-left .user-ip-info {
        display:none
    }
}


</style>
